import 'bootstrap/dist/css/bootstrap.min.css';

import moment from 'moment';
import { I18nextProvider } from 'react-i18next';
import i18n from './config/i18n';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import it_IT from 'antd/lib/locale/it_IT';
import en_US from 'antd/lib/locale/en_US';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import { Provider } from 'react-redux';
import store from './redux/store';

window.version = process.env.REACT_APP_VERSION;

const setAntLocale = () => {
  switch (i18n.language) {
    case 'IT':
      moment.locale('it');
      return it_IT;
    case 'EN':
      moment.locale('en-gb');
      return en_US;
    default:
      moment.locale('it');
      return it_IT;
  }
};

const Root = () => {
  if (process.env.REACT_APP_PREFIX == '') {
    return (
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <ConfigProvider locale={setAntLocale()}>
            <App />
          </ConfigProvider>
        </I18nextProvider>
      </BrowserRouter>
    );
  } else {
    if (process.env.REACT_APP_PREFIX == '/web/#') {
      return (
        <HashRouter>
          <I18nextProvider i18n={i18n}>
            <ConfigProvider locale={setAntLocale()}>
              <App />
            </ConfigProvider>
          </I18nextProvider>
        </HashRouter>
      );
    }
  }
};

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
